import { useState } from "react";
import { SalaryToPaid } from "tm-shared/types";

export interface SelectedDateSalaryState {
    salary: SalaryToPaid | null;
    error: string;
    isActive: boolean;
}

const INITIAL_STATE: SelectedDateSalaryState = {
    salary: null,
    error: "",
    isActive: false,
};

export const useSelectedDateSalary = () => {
    const [selectedDateSalary, setSelectedDateSalary] =
        useState<SelectedDateSalaryState>(INITIAL_STATE);

    return {
        selectedDateSalary,
        setSelectedDateSalary,
    };
};
